module.exports = __webpack_public_path__ + "static/media/leftbf.b431b2ad.png";